/**
 * Scroll to element with an offset
 * @param {string} selector proper css selector
 * @param {number} offset number which will determine how many pixels above/below the top of the element scroll will finish on.
 * For example `-100` offset ends in scrolling to 100px above the element
 * @param {string} behavior scroll behavior, can be either `smooth` or `auto` (which does the scroll in one jump)
 *
 * @returns {void}
 */

export function scrollTo(selector, offset, behavior = 'smooth') {
    if (typeof selector === 'undefined' || typeof offset !== 'number') {
        return;
    }

    const el = document.querySelector(selector);

    if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY + offset;
        window.scrollTo({ top, behavior });
    }
}
